import { useSelector } from "react-redux";
import { FaFilePdf } from "react-icons/fa";
import { convertToMarathiNumber } from "../../components/marathiNumbers";

// Document Imports
import Group_D_Employees from "../../assets/documents/Group_D_Employees.pdf";
import Group_C_employees from "../../assets/documents/Group_C_employees.zip";
import Group_C_Employees_Marathi from "../../assets/documents/Group_C_Employees_Marathi.zip";
import Group_D_Employees_Marathi from "../../assets/documents/Group_D_Employees_Marathi.pdf";
import { Link } from "react-router-dom";

const SenitoryPage = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Seniority List",
      breadcrumb: {
        home: "HOME",
        page: "SENIORITY LIST",
      },
    },
    मराठी: {
      title: "ज्येष्ठता सूची",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "ज्येष्ठता सूची",
      },
    },
  };

  const tableHeaders = {
    srNo: {
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    name: {
      English: "Name",
      मराठी: "नाव",
    },
    download: {
      English: "Download",
      मराठी: "डाउनलोड",
    },
  };

  const documents = [
    {
      id: 1,
      name: {
        English: "Group_C_Employees Seniority List",
        मराठी: "वर्ग ३ अधिकारी व कर्मचाऱ्यांची ज्येष्ठता सूची",
      },
      file: {
        English: Group_C_employees,
        मराठी: Group_C_Employees_Marathi,
      },
    },
    {
      id: 2,
      name: {
        English: "Group D Employees_Seniority_List 2024",
        मराठी: "वर्ग ड मधील कर्मचारी यांची जेष्ठता सूचीबाबत. 2024",
      },
      file: {
        English: Group_D_Employees,
        मराठी: Group_D_Employees_Marathi,
      },
    },
  ];

  const t = content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Page Title and Breadcrumb */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Table */}
      <div className="max-w-5xl mx-auto">
        <div
          className="bg-[#EFEDE0] rounded-xl overflow-x-auto no-dark-bg"
          style={{ border: "2px solid #F8D6BF" }}
        >
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead
              className="font-bold tracking-wide"
              style={{ textShadow: "0.3px 0.3px 0 black" }}
            >
              <tr>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.srNo[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.name[selectedLang]}
                </th>
                <th className="py-3 px-4" style={{ borderColor: "#F8D6BF" }}>
                  {tableHeaders.download[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {documents.map((doc, index) => (
                <tr key={doc.id} className="hover:bg-[#F6F6EC]">
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {selectedLang === "मराठी"
                      ? convertToMarathiNumber(index + 1)
                      : index + 1}
                    .
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {doc.name[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    <div className="flex justify-center items-center h-full">
                      <a
                        href={doc.file[selectedLang]}
                        download
                        title="Download PDF"
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaFilePdf size={20} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SenitoryPage;
